import { useClearCache } from 'react-clear-cache';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  BsFileEarmarkText, BsClipboardCheck, BsBarChartLineFill, BsCashCoin,
  BsPeopleFill, BsMortarboard, BsCalculator, BsBook,
} from 'react-icons/bs';
import packageInfo from '../../../package.json';
import logo from '../../assets/images/web.png';
import { setData } from '../../core/redux/app/Actions';
import GeneralDashboard from './components/GeneralDashboard/GeneralDashboard';

export default function DashboardScreen() {
  const { isLatestVersion, emptyCacheStorage, latestVersion } = useClearCache();
  const dispatch = useDispatch();
  const history = useHistory();

  const SHOW_QUICK_MENU = true;

  return (
    <div className="dashboard-placement">
      {SHOW_QUICK_MENU && (
      <div className="dashboard-home">
        <div>
          <img className="dashboard-logo" src={logo} />
        </div>
        <div className="dashboard-button-placement">
          <div
            className="location-button"
            onClick={() => {
              history.push(`/budgets`);
              dispatch(setData({ navigate: `/budgets` }));
            }}
          >
            <BsFileEarmarkText />
            <text>Orçamento</text>
          </div>

          <div
            className="location-button"
            onClick={() => {
              history.push(`/order-services`);
              dispatch(setData({ navigate: `/order-services` }));
            }}
          >
            <BsClipboardCheck />
            <text>Ordem de Serviço</text>
          </div>

          <div
            className="location-button"
            onClick={() => {
              history.push(`/reports`);
              dispatch(setData({ navigate: `/reports` }));
            }}
          >
            <BsBarChartLineFill />
            <text>Relatórios</text>
          </div>

          {/* <div
            className="deactivated-button"
          // onClick={() => {
          //   history.push(`/budgets`);
          //   dispatch(setData({ navigate: `/budgets` }));
          // }}
          >
            <text>Ordem de serviço</text>
          </div>
          <div
            className="deactivated-button"
          // onClick={() => {
          //   history.push(`/company`);
          //   dispatch(setData({ navigate: `/company` }));
          // }}
          >
            <text>Pátio</text>
          </div> */}
          <div
            className="location-button"
            onClick={() => {
              history.push(`/financial`);
              dispatch(setData({ navigate: `/financial` }));
            }}
          >
            <BsCashCoin />
            <text>Financeiro</text>
          </div>
        </div>
        <div className="dashboard-button-placement">
          <div className="twin-buttons">
            {/* <div
              className="deactivated-button"
            // onClick={() => {
            //   history.push(`/modules`);
            //   dispatch(setData({ navigate: `/modules` }));
            // }}
            >
              <text>Administração</text>
            </div> */}
            <div
              className="location-button"
              onClick={() => {
                history.push(`/register`);
                dispatch(setData({ navigate: `/register` }));
              }}
            >
              <BsPeopleFill />
              <text>Cadastro</text>
            </div>
            <div
              className="location-button"
              onClick={() => {
                history.push(`/manual`);
                dispatch(setData({ navigate: `/manual` }));
              }}
            >
              <BsMortarboard />
              <text>Cursos</text>
            </div>
          </div>
          <div
            className="location-button"
            onClick={() =>
              window.open(
                `${process.env.PUBLIC_URL}/calculadora-horas.html`,
                '_blank'
              )
            }
          >
            <BsCalculator />
            <text>Calculadora de Horas</text>
          </div>
          <div
            className="location-button"
            onClick={() => {
              history.push(`/manual-prospera/1`);
              dispatch(
                setData({
                  navigate: `/manual-prospera`,
                  courseName: null,
                })
              );
            }}
          >
            <BsBook />
            <text>Manual do PROSPERA</text>
          </div>
        </div>
      </div>
      )}

      <GeneralDashboard />

      <div className="text-version">
        <div>{packageInfo.version}</div>
      </div>
    </div>
  );
}
